import { useCallback, useEffect, useMemo, useState } from 'react';
import axiosInstance from '../axiosConfig';
import {
    filterBindingsStrategies,
    filterLegacyStrategies,
} from '../utils/strategyAccountModel';

export function useAdminStrategies() {
    const [strategies, setStrategies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const reload = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axiosInstance.get('/api/strategies');
            setStrategies(response.data || []);
        } catch (err) {
            console.error('Error fetching strategies:', err);
            setError('Failed to load strategies');
            setStrategies([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    const legacyStrategies = useMemo(
        () => filterLegacyStrategies(strategies),
        [strategies]
    );
    const bindingsStrategies = useMemo(
        () => filterBindingsStrategies(strategies),
        [strategies]
    );

    return {
        strategies,
        legacyStrategies,
        bindingsStrategies,
        loading,
        error,
        reload,
    };
}
